import { type BenchmarkDto, BenchmarkDtoSchema } from "@modules/benchmark/api/benchmarkDto"
import { type BenchmarkApiGateway } from "@modules/benchmark/api/benchmarkGateway"
import { LoggerService } from "@modules/common/logger/loggerService"
import { ApiClient } from "@modules/core/api/client/apiClient"
import { ConfigService } from "@modules/core/services/configService"

export class BenchmarkApi implements BenchmarkApiGateway {
  private baseUrl = "/benchmarks"
  private buildExploreUrl = () => `${ConfigService.config.BASE_URL.replace("/web", "")}/mobile${this.baseUrl}`

  constructor(private api: ApiClient) {}

  async getBenchmark(id: string): Promise<BenchmarkDto> {
    const resultDto = await this.api.get<BenchmarkDto>(`${this.buildExploreUrl()}/${id}`)
    return LoggerService.parseApiDto(BenchmarkDtoSchema, resultDto.data)
  }
}
